<template>
  <div id="add-new-order-modal">
    <!-- <v-layout row justify-center> -->
    <v-dialog v-model="sendToBranchModal" persistent max-width="450px">
      <v-card>
        <form action="" @submit.prevent="submitForm()">
          <v-card-title>
            <v-flex xs11 sm11 md11><span class="headline">Send to Branch</span></v-flex>
            <v-flex xs1 sm1 md1>
              <v-btn flat @click="closeSendToBranchModal" class="close">&times;</v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 sm2 md2>
                  <v-checkbox
                    style="padding: 0px;"
                    label="Send SMS"
                    v-model="sendToBranchData.send_sms"
                    color="indigo"
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="QrCode*"
                    v-model="sendToBranchData.order_id"
                    :error-messages="errors.collect('qrcode')"
                    v-validate="'required'"
                    data-vv-name="qrcode"
                    autofocus
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div style="height:0px;overflow:hidden">
              <v-btn id="sendButton" type="submit" style="height:auto" outline color="success"
                >Send</v-btn
              >
            </div>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
    <!-- </v-layout> -->
  </div>
</template>
<script>
export default {
  props: ['sendToBranchModal', 'closeSendToBranchModal', 'sendToBranchData', 'sendToBranch'],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.sendToBranch()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sendToBranch.vue